import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_delivery_tax_invoice, report_delivery_note } from "../../../components/Report.js";
export default class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,

      filter_search: "",
      filter_start_date: format_date(new Date(new Date().getFullYear(),new Date().getMonth(), 1),"yyyy-mm-dd"),
      filter_end_date: format_date(new Date(),"yyyy-mm-dd"),
      filter_status: "",

      data: [],
      data_customer: [],
      data_invoice: [],
      count: 10,

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
      customer_id: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date, filter_status } =
      this.state;
    let data, count, data_customer;
    loading(true);
    let [result, result_customer] = await Promise.all([
      GET("admin/invoices/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        status_code: filter_status,
        customer_id: ""
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    this.setState({
      data,
      count,
      data_customer,
    });
    loading(false);
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิก",
        "ยืนยันรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/invoices/update/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      data,
      data_customer,
      data_invoice,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      customer_id,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ใบแจ้งหนี้/ใบส่งของ</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="ใบวางบิล">ใบวางบิล</option>
                <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่ส่งสินค้า</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">กำหนดชำระ</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">ประเภท Vat</td>
                    <td className="text-nowrap text-end">จำนวนเงิน (บาท)</td>
                    <td className="text-nowrap text-end">ลดหนี้</td>
                    <td className="text-nowrap text-end">มูลค่าหลังลดหนี้</td>
                    <td className="text-nowrap text-end">ชำระมัดจำ</td>
                    <td className="text-nowrap text-end">ชำระบางส่วน</td>
                    <td className="text-nowrap text-end">ค้างชำระ</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => {
                    item.credit_note = item.credit_note.filter(e=>e.status !== "ยกเลิก")
                  return (
                    <tr>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.sale?.due_date
                          ? format_date(item.sale?.due_date)
                          : item.repair?.due_date
                          ? format_date(item.repair?.due_date)
                          : format_date(new Date())}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.customer?.full_name || item.repair?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.receipt_type || item.repair?.receipt_type || ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {
                        item.sale ? toFixed(Number(item.sale?.amount_net) + Number(item.sale?.vat || 0)) :
                        item.repair ? toFixed((item.repair?.receipt_type === "ต้องการ Vat" ? item.repair?.amount_net * 1.07 : item.repair?.amount_net)) : ""
                        }
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(total(item.credit_note,"amount"))}
                      </td>
                      <td className="text-nowrap text-end">
                        {
                        item.sale ? toFixed(Number(item.sale?.amount_net) + Number(item.sale?.vat || 0) - total(item.credit_note,"amount")):
                        item.repair ? toFixed((item.repair?.receipt_type === "ต้องการ Vat" ? (item.repair?.amount_net-total(item.credit_note,"amount")) * 1.07 : (item.repair?.amount_net-total(item.credit_note,"amount")))) : ""
                        }
                      </td>
                      <td className="text-nowrap text-end">
                        {
                        item.sale ? toFixed(item.sale?.amount_deposit) :
                        item.repair ? toFixed(item.repair?.amount_deposit) :
                         "-"
                         }
                      </td>
                      <td className="text-nowrap text-end">
                        {
                        item.sale ? toFixed(item.sale?.total_pay - item.sale?.amount_deposit):
                        item.repair ? toFixed(item.repair?.total_pay - item.repair?.amount_deposit):
                         "-"
                         }
                      </td>
                      <td className={`text-nowrap text-end ${
                        item.sale ? 
                          (item.sale?.receipt_type === "ต้องการ Vat" ? (item.sale?.amount_net-total(item.credit_note,"amount")) *1.07: (item.sale?.amount_net-total(item.credit_note,"amount"))) -
                            Number(item.sale?.discount) - Number(item.sale?.total_pay) - 
                            Number(item.sale?.amount_deposit) !==
                          0
                            ? Number(item.sale?.total_pay) !== 0
                              ? "text-warning"
                              : "text-danger"
                            : "text-dark" :
                          (item.repair?.receipt_type === "ต้องการ Vat" ? (item.repair?.amount_net-total(item.credit_note,"amount")) *1.07: (item.repair?.amount_net-total(item.credit_note,"amount"))) -
                            Number(item.sale?.discount) - Number(item.repair?.total_pay) - 
                            Number(item.repair?.amount_deposit) !==
                          0
                            ? Number(item.repair?.total_pay) !== 0
                              ? "text-warning"
                              : "text-danger"
                            : "text-dark"
                        }`}>
                         {
                         item.sale ? 
                         toFixed(
                          (item.sale?.receipt_type === "ต้องการ Vat" ? (item.sale?.amount_net-total(item.credit_note,"amount")) *1.07: (item.sale?.amount_net-total(item.credit_note,"amount"))) -
                            Number(item.sale?.discount) - Number(item.sale?.total_pay)
                        ) : 
                        item.repair ? 
                         toFixed(
                          (item.repair?.receipt_type === "ต้องการ Vat" ? (item.repair?.amount_net-total(item.credit_note,"amount")) *1.07: (item.repair?.amount_net-total(item.credit_note,"amount"))) -
                            Number(item.repair?.discount) - Number(item.repair?.total_pay)
                        ) : ""}
                      </td>
                      <td className="text-nowrap">{item.status}</td>
                      <td className="text-center align-middle wpx-140">
                        <div className="d-flex">
                          {["เสร็จสิ้น"].includes(item.status)  && (
                          <BtnIcon type="view" onClick={() => {
                             window.location.href =
                                  "/invoice/payment-invoices?id=" + item.uid + "&type=view";
                          }} />)}
                          {["รอชำระ","ใบวางบิล"].includes(item.status) && (
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                window.location.href =
                                  "/invoice/payment-invoices?id=" + item.uid;
                              }}
                            />
                          )}
                          <BtnIcon type="print" onClick={() => {
                            Swal.fire({
                                    title: "พิมพ์เอกสาร",
                                    text: "",
                                    html:`
                                      <div class="w-100">
                                      <button id="report-delivery-tax-invoice" class="btn btn-outline-dark w-100 mb-3 text-start">
                                        <span class="icon me-2">&#xf15b;</span>
                                        ใบส่งของ/ใบกำกับภาษี
                                      </button>
                                      <button id="report-delivery-note" class="btn btn-outline-dark w-100 mb-3 text-start">
                                        <span class="icon me-2">&#xf15b;</span>
                                        ใบส่งของ
                                      </button>
                                        </div>
                                    `,
                                    showConfirmButton: false,
                                    showCancelButton: false,
                                    showCloseButton: true,
                                    didOpen: () => {
        document.getElementById("report-delivery-tax-invoice").addEventListener("click", () => {
          report_delivery_tax_invoice(item.uid);
        });
        document.getElementById("report-delivery-note").addEventListener("click", () => {
          report_delivery_note(item.uid);
        });
                                    }
                                  })
                          }} />
                          {item.status === "รอชำระ" && (
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )})}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
